

export function getBatchTimeRemainingStyle(
    batchTimeRemaining: number | null,
    partCount: number | null | undefined,
    targetQuantity: number | null | undefined,
    inOfflineMode: boolean,
): React.CSSProperties {
    const warningPeriodMillis = 8 * 3_600_000;
    const considerCount = targetQuantity != null && targetQuantity > 0 && !inOfflineMode;
    const countReached = partCount != null && targetQuantity != null && partCount >= targetQuantity;
    const timerReached = batchTimeRemaining != null && batchTimeRemaining <= 0;
    const requiresMeasuring = considerCount ? countReached : timerReached;

    let cellStyle: React.CSSProperties = {};
    if (requiresMeasuring) {
        cellStyle = { color: 'red' };
    } else if (batchTimeRemaining != null && batchTimeRemaining <= warningPeriodMillis) {
        cellStyle = { color: 'orange' };
    }
    return cellStyle;
}
